/* Package JSON Import will be here */
import { findIndex, filter, forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getTodayDateWithYearMonthDateFormat } from "utilities/utils";
/* Project Import will be here */

export const types = {
    UPDATE_EXCHANGE_RETURN_SUMMARY: "exchangeReturnSummary/UPDATE_EXCHANGE_RETURN_SUMMARY",
    CLEAR_EXCHANGE_RETURN_SUMMARY: "exchangeReturnSummary/CLEAR_EXCHANGE_RETURN_SUMMARY"
};

const initialState = {
    isLoading: false,
    data: [],
    error: null,
    returnUpload: {
        isLoading: false,
        error: null,
    }
};

export const exchangeReturnSummary = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_EXCHANGE_RETURN_SUMMARY:
            return {
                ...state,
                data: action.payload.updatedData
            };
        case types.CLEAR_EXCHANGE_RETURN_SUMMARY:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

/* Clear exchange return summary on every exchange return load */
export const clearExchangeReturnSummary = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CLEAR_EXCHANGE_RETURN_SUMMARY });
    }
};

/* Update exchange return summary */
export const updateExchangeReturnSummary = (selectedProduct, reasonQtyList) => {
    return async (dispatch, getState) => {
        /* Check if the product added in the added in the summary */
        const summaryProductList = getState().exchangeReturnSummary.data;
        let tempSummaryProductList = summaryProductList.slice();
        const selectedProductIndex = findIndex(tempSummaryProductList, o => { return o.ProductId === selectedProduct.ProductId });

        /* Remove selected item */
        if (selectedProductIndex !== -1)
            tempSummaryProductList.splice(selectedProductIndex, 1);

        /* Add the selected item if any one of the reason qty > 0 */
        const checkQtyAdded = filter(reasonQtyList, o => { return o.selectedPieceQty > 0 || o.selectedCaseQty > 0 });
        if (checkQtyAdded.length > 0) {

            let reasonList = [];
            let totalQty = 0;
            forEach(reasonQtyList, o => {
                let qtyCount = o.selectedPieceQty;
                if (o.selectedCaseQty > 0)
                    qtyCount = qtyCount + (selectedProduct.ConversionQty * o.selectedCaseQty)

                reasonList.push({ ReasonId: o.reasonId, ReasonName: o.reasonName, Qty: qtyCount });

                /* Get total qty */
                totalQty = totalQty + qtyCount;
            });

            const requestObj = {
                ConversionQty: selectedProduct.ConversionQty,
                MfgDate: getTodayDateWithYearMonthDateFormat(),
                PrincipalId: selectedProduct.PrincipalId,
                ProductId: selectedProduct.ProductId,
                ProductName: selectedProduct.ProductName,
                Reasons: reasonList,
                TotalQty: totalQty,
                UomId: selectedProduct.UomId
            }
            tempSummaryProductList.push(requestObj);
        }

        dispatch({
            type: types.UPDATE_EXCHANGE_RETURN_SUMMARY,
            payload: { updatedData: tempSummaryProductList }
        });
    }
};